import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicMiami from "../Components/ProjPicMiami";

const ProjectPageMiami = () => {
    return (
        <>
            <Navbar />
            <ProjPicMiami />
            <Footer />
        </>
    );
};

export default ProjectPageMiami;
